import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  message,
  App,
  Radio,
  Tag,
  Divider,
} from "antd";
import {
  UserOutlined,
  SaveOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { TOOL_SETTING, UPDATE_ADMIN_PROFILE } from "../../apis/apis";
import CulsightPageLoader from "../../components/CulsightPageLoader";

export default function ToolSetting() {
  const { notification } = App.useApp();

  // Separate forms
  const [profileForm] = Form.useForm();
  const [toolForm] = Form.useForm();

  const [loading, setLoading] = useState(true);

  // Profile state
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    email: "",
    role: "",
  });

  // Tool state
  const [toolData, setToolData] = useState({
    lms_secret: "",
    awarness_url: "",
    smtp_server: "",
    smtp_user: "",
    smtp_port: "",
    password: "",
    assign_course: 0,
  });

  // ================= PROFILE =================

  const getProfile = async () => {
    try {
      const res = await UPDATE_ADMIN_PROFILE();
      if (res?.data?.status) {
        const data = res?.data?.data;

        setProfile({
          first_name: data?.first_name || "",
          last_name: data?.last_name || "",
          email: data?.email || "",
          role: data?.roles || "",
        });

        profileForm.setFieldsValue({
          first_name: data?.first_name,
          last_name: data?.last_name,
        });


      }
    } catch (err) {
      message.error("Failed to load profile");
    }
  };

  const handleProfileSubmit = async (values) => {
    setLoading(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("first_name", values.first_name);
    FORM_DATA.append("last_name", values.last_name);

    try {
      const res = await UPDATE_ADMIN_PROFILE(FORM_DATA);

      if (res?.data?.status) {
        notification.success({
          message: "Success",
          description: res?.data?.message,
        });

        // ✅ 1. Pehle profile state local update karein taaki page par turant dikhe
        getProfile();

        // ✅ 2. LocalStorage se user nikaalein (Ye missing tha)
        const localUserData = localStorage.getItem("user");
        if (localUserData) {
          const currentUser = JSON.parse(localUserData);

          // Naya object banayein updated name ke saath
          const updatedUser = {
            ...currentUser,
            user_info: {
              ...currentUser.user_info,
              name: `${values.first_name} ${values.last_name}`
            }
          };

          // Local storage mein wapas save karein
          localStorage.setItem("user", JSON.stringify(updatedUser));

          // ✅ 3. Event dispatch karein taaki MasterTemplate ko pata chale
          window.dispatchEvent(new Event("storage_updated"));
        }

      } else {
        notification.error({
          message: "Error",
          description: res?.data?.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Server Error",
        description: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  // ================= TOOL SETTINGS =================

  const getToolSettings = async () => {
    try {
      const res = await TOOL_SETTING();
      if (res?.data?.status) {
        const data = res?.data?.data;

        const updated = {
          lms_secret: data?.lms_secret || "",
          awarness_url: data?.awarness_url || "",
          smtp_server: data?.smtp_server || "",
          smtp_user: data?.smtp_user || "",
          smtp_port: data?.smtp_port || "",
          password: data?.password || "",
          assign_course: data?.meta?.assign_course_on_click || 0,
        };

        setToolData(updated);
        toolForm.setFieldsValue(updated);
      }
    } catch {
      message.error("Failed to load tool settings");
    } finally {
      setLoading(false);
    }
  };

  const handleToolSubmit = async (values) => {
    setLoading(true);

    const FORM_DATA = new FormData();
    Object.keys(values).forEach((key) => {
      FORM_DATA.append(key, values[key]);
    });

    try {
      const res = await TOOL_SETTING(FORM_DATA);

      if (res?.data?.status) {
        notification.success({
          message: "Saved",
          description: res?.data?.message,
        });
      } else {
        notification.error({
          message: "Error",
          description: res?.data?.message,
        });
      }
    } catch (error) {
      message.error(
        "Server Error: " +
        (error?.response?.data?.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  // ================= INIT =================

  useEffect(() => {
    setLoading(true);
    Promise.all([getProfile(), getToolSettings()]).finally(() =>
      setLoading(false)
    );
  }, []);

  // ================= UI =================

  if (loading) return <CulsightPageLoader />;

  return (
    <div className="lms-body">
      <h1>Settings</h1>
      <span style={{ color: "#6c757d" }}>
        Manage your account and preferences
      </span>

      {/* ================= PROFILE ================= */}
      <Card style={{ marginTop: 20 }}>
        <h2>
          <UserOutlined style={{ color: "#8c3add" }} /> Profile Setting
        </h2>

        <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
          <Tag
            color="#8c3add"
            style={{
              height: 80,
              width: 80,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 30,
            }}
          >
            {profile.first_name?.charAt(0)}
          </Tag>

          <div style={{ marginLeft: 20, marginTop: 0, lineHeight: .7 }}>
            <h2>
              {profile.first_name} {profile.last_name}
            </h2>
            <div style={{ color: "gray" }}>{profile.email}</div>
            <Tag color="#ede9fe" style={{ marginTop: 5 }}>
              <span style={{ color: "#8c3add" }}>{profile.role === "phishing_user" ? "Phishing User" : "Admin"}</span>
            </Tag>
          </div>
        </div>

        <Divider />

        <Form
          layout="vertical"
          form={profileForm}
          onFinish={handleProfileSubmit}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="first_name"
                label="First Name"

              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="last_name"
                label="Last Name"

              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Email"

              >
                <Input value={profile.email} disabled /></Form.Item>
            </Col>
            <Col span={12}>

              <Form.Item
                label="Role"
              >
                <Input value={profile.role === "phishing_user" ? "Phishing User" : "Admin"} disabled /></Form.Item>
            </Col>

          </Row>

          <Button type="primary" htmlType="submit" style={{ marginTop: 15,float:"right" }}>
            <SaveOutlined /> Save Changes
          </Button>
        </Form>
      </Card>

      {/* ================= TOOL SETTINGS ================= */}
      <Card style={{ marginTop: 30 }}>
        <h2>
          <SettingOutlined style={{ color: "#8c3add" }} /> Tool Settings
        </h2>

        <Form
          form={toolForm}
          layout="vertical"
          onFinish={handleToolSubmit}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="lms_secret" label="LMS Secret">
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="awarness_url" label="Awareness URL">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item name="assign_course" label="Assign Course">
            <Radio.Group>
              <Radio value={0}>No</Radio>
              <Radio value={1}>Yes</Radio>
            </Radio.Group>
          </Form.Item>

          <Divider>SMTP Settings</Divider>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="smtp_server" label="SMTP Server">
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="smtp_user" label="SMTP User">
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="smtp_port" label="SMTP Port">
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="password" label="SMTP Password">
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>

          <Button type="primary" htmlType="submit" style={{ float: "right" }}>
            Save Settings
          </Button>
        </Form>
      </Card>
    </div>
  );
}